import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ReactiveFormsModule} from "@angular/forms";
import {FormFieldModule} from "../../../../../../core/component/form-field/form-field.module";
import {FormModule} from "../../../../../../form/form.module";
import {SaleInvoiceReportOptionsInputFormComponent} from "./sale-invoice-report-options-input-form.component";
import {ReportCommonOptionsInputFormModule} from "../../../../../../reporting/report/api/component/report-common-options-input-form/report-common-options-input-form.module";
import {CardModule} from '../../../../../../core/component/card/card.module';
import {EditAddressModule} from '../../../../../../common/address/component/edit-address/edit-address.module';
import {
    ReportRecipientInputFormModule
} from '../../../../../../reporting/report/api/component/report-recipient-input-form/report-recipient-input-form.module';
import {IonicModule} from '@ionic/angular';
import {
    CheckboxInputModule
} from '../../../../../../../components/common/checkbox/checkbox-input/checkbox-input.module';
import {LoadingModule} from "../../../../../../../components/common/loading/loading.module";
import {
    ServiceContainerComponent
} from "../../../../../../core/component/service-container/service-container.component";

@NgModule({
    imports: [
        CommonModule,
        FormModule,
        ReactiveFormsModule,
        FormFieldModule,
        ReportCommonOptionsInputFormModule,
        CardModule,
        EditAddressModule,
        ReportRecipientInputFormModule,
        IonicModule,
        CheckboxInputModule,
        LoadingModule,
        ServiceContainerComponent,
    ],
    declarations: [SaleInvoiceReportOptionsInputFormComponent],
    exports: [
        SaleInvoiceReportOptionsInputFormComponent
    ]
})
export class SaleInvoiceReportOptionsInputFormModule {
}
